export default __webpack_public_path__ + "static/media/newlogo.cdf87cc3.webp";